<template>
  <div>
    <app-add-person></app-add-person>
    <b-form-group>
      <div v-if="dataLoaded == false" class="text-center">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <p>Loading</p>
      </div>
      <b-form-select
        v-model="filter"
        :options="filterOptions"
        @change="getFilteredData()"
      ></b-form-select>
      <b-form-input
        v-model="tableFilter"
        placeholder="Filter by text"
      ></b-form-input>
    </b-form-group>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
      :filter="tableFilter"
      head-row-variant="info"
      @row-clicked="navigate($event)"
      primary-key="id_no"
      :per-page="perPage"
      :current-page="currentPage"
    ></b-table>
  </div>
</template>

<script>
import AddPerson from "./personAddComponents/AddPersonHome";
export default {
  components: {
   appAddPerson:AddPerson,
  },
  computed: {
    djangoToken() {
      return this.$store.getters.djangoToken;
    },
    rows() {
      return this.items.length;
    },
    peopleList() {
      return this.$store.getters.peopleList;
    }
  },
  
  watch:{
    peopleList: function(){
      this.presentData(this.peopleList);
    }
  },

  data() {
    return {
      items: [],
      fields: [
        
        { key: "name", sortable: false },
        { key: "address", sortable: false },
        { 
        key: "D.O.B", 
        sortable: false,
        formatter:(key)=>{
          if (key == null){
            return 'dd/mm/yyyy'
          }
          const date = key.split('-')
          return date[2]+'/'+date[1]+'/'+date[0]
        }
        },
        { key: "EmergencyContact", sortable: false },
        { key: "EmergencyContactPhone", sortable: false },
        { key: "MemberNo.", sortable: false }
      ],
      results: {},
      error: "",
      clickResult: {},
      filter: "active",
      filterOptions: [
        { value: "active", text: "Filter by active members" },
        { value: "inactive", text: "Filter by inactive members" },
        {
          value: "parent",
          text: "Filter by parents and other responsible people"
        }
      ],
      tableFilter: null,

      perPage: 40,
      currentPage: 1,
      response: null,
      dataLoaded:false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let post_url;
      if (this.nextUrl == null) {
        post_url =
          this.$store.state.urlPrefix +
          "api/people/?limit=20&offset=0&search_filter=" +
          this.filter;
      } else {
        post_url = this.nextUrl;
      }
      const payload = {
        mutationName: "peopleList",
        url: post_url,
        djangoToken: this.djangoToken
      };
      this.$store
        .dispatch("genericGetApiCall", payload);
    },

    presentData(response) {
      // agregates fields for presentation from the response object.
      //const displayTemplate = {'name':'', 'address':'', 'D.O.B':'', 'EmergencyContact':'', 'EmergencyContactPhone':'', 'MemberNo':''};
      //var displayList = [];
      //var index = 0;
      var prepData = [];
      var item;
      for(item in response){
        const personObject = response[item];
        //eslint-disable-next-line no-console
        //console.log(personObject);
      var memberNo;
        if (personObject.yourIdeasId == null) {
          memberNo = personObject.id + " dj";
        } else {
          memberNo = personObject.yourIdeasId + " fm";
        }



        const name = personObject.firstName + ' '+ personObject.lastName;
        const address = personObject.addressLine1 + ' ' + personObject.postCode;
        const EmergencyContact = personObject.emergency_contact_detail.firstName + ' ' +  personObject.emergency_contact_detail.lastName;
        const EmergencyContactPhone = personObject.emergency_contact_detail.preferedPhone
        


        var line = {'name':name, 'address':address, 'D.O.B':personObject.dateOfBirth, 'EmergencyContact': EmergencyContact, 'EmergencyContactPhone':EmergencyContactPhone, 'MemberNo':memberNo, 'id_no': personObject.id}
        prepData.push(line)
        // // date of birth
        // response[item]['D O B'] = personObject.dateOfBirth;
      
        // // combine first and last name into name
        // personObject.name = personObject.firstName+' '+personObject.lastName;
        // //delete personObject.firstName;
        // //delete personObject.lastName;
        // personObject.address = personObject.addressLine1+' '+personObject.postCode;
        // personObject.EmergencyContact = personObject.list_emergency_contact.firstName +' '+ personObject.list_emergency_contact.lastName;
        // personObject.EmergencyContactPhone = personObject.list_emergency_contact.phone;
        // personObject.id_no = personObject.id;

       
        // personObject.MemberNo = memberNo


      }

      // 
      //every time we ask for more items we add them to this.items building up the list to be displayed
      this.items = prepData;
      this.dataLoaded = true;
    },

    formatDate(date){
      this.$store.dispatch('formatDate', date);
      return this.$store.getters.formatDate;
    },
    navigate(data) {
      const personId = data.id_no;
      this.$router.push("/person/" + personId);
    },
    getFilteredData() {
      this.getData();
    }
  }
};
</script>
<style scoped></style>
